import React from 'react';
import './SubcategoriesActionOption.css';
import classNames from 'classnames';
import { SvgIconMask } from '../../../../../shared/src/components/SvgIconMask';
import { useDeviceTypeHook } from '../../../../../shared/src/hooks/use-device-type.hook';

export const SubcategoriesActionOption = ({
    option,
    clickHandler,
    className = null,
    buttonClass = null,
}) => {
    const { isMobile } = useDeviceTypeHook();

    const itemClassName = classNames(
        'asg-subcategories__actions-options-item',
        className
    );
    const buttonClassName = classNames(
        'asg-subcategories__actions-options-item-button',
        buttonClass,
        {
            'asg-subcategories__actions-options-item-button--active': option?.selected || false,
            'asg-subcategories__actions-options-item-button--desktop': !isMobile,
        },
    );

    return <li className={itemClassName}>
        <button className={buttonClassName}
            onClick={() => clickHandler(option)}
        >
            {option.icon && <SvgIconMask
                iconUrl={option.icon}
                className="asg-subcategories__actions-options-item-icon"
                bgColor="var(--cs-body-text-color)"
                width=""
                height=""
            />}

            <span className="asg-subcategories__actions-options-label">
                {option.label}
            </span>
        </button>
    </li>;
};
